// Currency conversion utilities

// Get currency symbol from currency code
export const getCurrencySymbol = (currencyCode) => {
  const currencySymbols = {
    'USD': '$', 'EUR': '€', 'GBP': '£', 'JPY': '¥', 'CAD': 'CA$', 'AUD': 'A$',
    'CNY': '¥', 'INR': '₹', 'BRL': 'R$', 'MXN': 'MX$', 'CHF': 'CHF', 'SEK': 'kr',
    'NZD': 'NZ$', 'SGD': 'S$', 'HKD': 'HK$', 'NOK': 'kr', 'KRW': '₩', 'TRY': '₺',
    'RUB': '₽', 'ZAR': 'R', 'PLN': 'zł', 'THB': '฿', 'IDR': 'Rp', 'MYR': 'RM',
    'PHP': '₱', 'DKK': 'kr', 'CZK': 'Kč', 'ILS': '₪', 'CLP': 'CL$', 'AED': 'د.إ'
  };
  return currencySymbols[currencyCode] || currencyCode;
};

// Convert currency (approximate rates)
export const convertCurrency = (amount, fromCurrency, toCurrency) => {
  if (fromCurrency === toCurrency) return amount;

  const rates = {
    'USD': 1, 'EUR': 0.92, 'GBP': 0.79, 'JPY': 149.50, 'CAD': 1.36, 'AUD': 1.53,
    'CHF': 0.88, 'CNY': 7.24, 'INR': 83.12, 'BRL': 4.97, 'MXN': 17.08,
    'SEK': 10.43, 'NZD': 1.65, 'SGD': 1.34, 'HKD': 7.83, 'NOK': 10.68,
    'KRW': 1320.50, 'TRY': 32.15, 'RUB': 92.50, 'ZAR': 18.65, 'PLN': 4.02,
    'THB': 35.12, 'IDR': 15678, 'MYR': 4.48, 'PHP': 56.23, 'DKK': 6.87,
    'CZK': 22.95, 'ILS': 3.68, 'CLP': 968.50, 'AED': 3.67
  };

  const amountInUSD = amount / (rates[fromCurrency] || 1);
  const convertedAmount = amountInUSD * (rates[toCurrency] || 1);

  if (['JPY', 'KRW', 'IDR', 'CLP'].includes(toCurrency)) {
    return Math.round(convertedAmount);
  }
  return Math.round(convertedAmount * 100) / 100;
};
